import React, { useState } from "react";
import {
  FormTab,
  SelectInput,
  required,
  BooleanInput,
  NumberInput,
} from "react-admin";
import { useForm } from "react-final-form";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { DatePicker } from "@material-ui/pickers";

interface SubscriptionFormGeneralInfoTabProps {}

const tenants = [{ id: 1, name: "Test" }];

export const SubscriptionFormGeneralInfoTab = (
  props: SubscriptionFormGeneralInfoTabProps
) => {
  const form = useForm();
  const [isTrial, setIsTrial] = useState<boolean>();
  return (
    <FormTab
      label="resources.master-subscriptions.labels.generalInformation"
      {...props}>
      <SelectInput
        source="tenantId"
        label="resources.master-subscriptions.labels.tenantName"
        validate={required()}
        choices={tenants}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        validate={required()}
        source="startDate"
        label="resources.master-subscriptions.labels.startDate"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
      />
      <BooleanInput
        source="isTrial"
        label="resources.master-subscriptions.labels.isTrial"
        onChange={(value) => {
          if (value) {
            form.change("isAutoRenew", false);
          }

          setIsTrial(value);
        }}
      />
      <NumberInput
        source="durationMonths"
        label="resources.master-subscriptions.labels.durationMonths"
        validate={required()}
      />
      <NumberInput
        source="minDurationMonths"
        label="resources.master-subscriptions.labels.minDurationMonths"
        disabled={isTrial}
      />
      <BooleanInput
        source="isAutoRenew"
        label="resources.master-subscriptions.labels.isAutoRenew"
        disabled={isTrial}
      />
    </FormTab>
  );
};
